export enum ModalNamesEnum {
  ChatsHistory = 'chats-history',
  VisitsHistory = 'visits-history',
  Otp = 'otp',
  Payment = 'payment',
  Call = 'call',
  FilePicker = 'file-picker',
  TransactionsHistory = 'transactions-history',
  NotificationPreferences = 'notification-preferences',
  ProfileSettings = 'profile-settings',
  Availability = 'availability',
  PatientSurvey = 'patient-survey',
  EndVisitConfirmation = 'end-visit-confirmation',
  TermsAndConditions = 'terms-and-conditions',
  VideoPlayer = 'video-player',
  ImageZoom = 'image-zoom',
  PdfView = 'pdf-view',
}
